import { render } from "./otherComponent.vue?vue&type=template&id=8fd2347e&scoped=true"
import script from "./otherComponent.vue?vue&type=script&lang=js"
export * from "./otherComponent.vue?vue&type=script&lang=js"

import "./otherComponent.vue?vue&type=style&index=0&id=8fd2347e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd2347e"]])

export default __exports__